import { Injectable } from '@angular/core';
import {PublicationService} from "../publications/publication.service";
import {LoadingController, ModalController} from "@ionic/angular";
import Swal from "sweetalert2";
import { request } from 'http';
import { RequestService } from '../request/request.service';
import { PublicationSaveTemplateComponent } from './../../components/publication/publication-save-template/publication-save-template.component';
import { FormServiceService } from '../publications/form-service.service';
import { Capacitor } from '@capacitor/core';
import { NativeSpotlight } from 'src/app/plugins/native-runtime.plugins';

@Injectable({
  providedIn: 'root'
})
export class ActualizacionServiceService {
  public current_page:number = 1;
  public loading: any;
constructor(
  private publicationService: PublicationService,
  private loadingController:LoadingController,
  private request: RequestService,
  private modalctrl:ModalController,
  private formService: FormServiceService
) { }

  private indexPostsForSpotlight(publications: any[], userId?: number): void {
    if (Capacitor.getPlatform() !== 'ios' || userId) return;
    const items = publications.slice(0, 100).filter(publication =>
      Number.isInteger(Number(publication?.id)) && Number(publication.id) > 0
    ).map(publication => {
      const summary = String(publication.description || '').replace(/<[^>]*>/g, ' ').trim();
      return {
        id: `post:${publication.id}`,
        title: String(publication.title || summary.slice(0, 90) || 'Laniakea post'),
        summary: summary.slice(0, 500),
      };
    });
    if (items.length) void NativeSpotlight.indexItems({ items }).catch(() => undefined);
  }

  /**
   * Adapt a raw API publication for legacy consumers such as the fullscreen
   * media template without inserting it into a shared feed cache.
   */
  normalizePublication(publication: any): Promise<any> {
    return this.publicationService.updatePublicationList('none', publication, false);
  }

async showLoading() {
  this.loading = await this.loadingController.create({
    message: '⚡️⚡️⚡️',
    spinner: 'circular',
    cssClass: 'custom-loader',
    backdropDismiss: false,
    translucent: true
  });

  await this.loading.present();

  const loaderElement = document.querySelector('ion-loading') as HTMLIonLoadingElement;
  const spinnerElement = loaderElement.querySelector('.loading-spinner') as HTMLElement;
  
  if (spinnerElement) {
    spinnerElement.style.background = 'black';
    spinnerElement.style.border = '1px solid white';
    spinnerElement.style.borderRadius = '6px';
    spinnerElement.style.backgroundImage = 'url("https://laniakea-multimedia.s3.amazonaws.com/electric.gif")';
    spinnerElement.style.backgroundSize = 'cover';
  }
}





async dismissLoading() {
  try {
    if (this.loading) {
      await this.loading.dismiss();
      this.loading = null;
    } else {
      console.log('Loading is already dismissed or not initialized.');
    }
  } catch (err) {
    console.log('Error while dismissing the loading:', err);
  }
}

  getPubFromServer(user_id ?: number, publication_type?: string) {
    return Promise.resolve(this.publicationService.getAllPublications(this.current_page, (user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined));
  }

  async getPublications(event: any, isrefresh: boolean, user_id?: number, show_loading?: boolean, publication_type?: string): Promise<any[]> {
    try{
     // if (show_loading == undefined) {
      //  console.log('showing the loading');
        //this.showLoading();
      //}
      if(isrefresh == true || isrefresh == null) {
        this.current_page = 1;
      }
      if (event !== null){
        event.target.complete();
      }
      const data = await this.getPubFromServer((user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined);
      const result = data['data'];
      let new_publications = [];
      let to = data['to'];
      for (let i = data['from']-1; i<to; i++) {
        const objectPublication = result[i.toString()];
        console.log('objectPublication:', objectPublication);
        const publication = await this.publicationService.updatePublicationList('MyFeedList', objectPublication);
        new_publications.push(publication);
      }
    //  if(show_loading == undefined){
      //  this.loading.dismiss();
     //   console.log('hidding the loading');
     // }
      this.indexPostsForSpotlight(new_publications, user_id);
      return new_publications;
    }
    catch (err){
    //  this.loading.dismiss();
      console.log('errorr in get publications', err);
      return [];
    }
  }

  
  async getPublicationsSave(event: any, isrefresh: boolean, user_id?: number, show_loading?: boolean, publication_type?: string): Promise<any[]> {
    const shouldShowLoading = show_loading === undefined;
    try {
      if (shouldShowLoading) {
        console.log('showing the loading');
        this.showLoading();
      }
      if (isrefresh == true || isrefresh == null) {
        this.current_page = 1;
      }
      if (event !== null) {
        event.target.complete();
      }
      // The API requires the users.id query parameter. When legacy callers do
      // not provide it, use the authenticated user id from the shared profile;
      // never substitute the profile id because those identifiers differ.
      const authenticatedUserId = user_id ?? Number(this.formService.profile?.user_id);
      const resolvedUserId = Number.isSafeInteger(authenticatedUserId) && authenticatedUserId > 0
        ? authenticatedUserId
        : undefined;
      if (!resolvedUserId) {
        if (shouldShowLoading && this.loading) await this.dismissLoading();
        return [];
      }
      const data = await this.getSavePubFromServer(resolvedUserId, publication_type ? publication_type : undefined);
      // Laravel's paginator historically returned an object keyed by numeric
      // indexes plus `from`/`to`; newer deployments return `data` as an array
      // (and some wrap that payload in another `data` object). Normalize both
      // shapes so saved publications are never silently dropped.
      const envelope: any = data && typeof data === 'object' ? data : {};
      const nested: any = envelope.data && typeof envelope.data === 'object' && !Array.isArray(envelope.data)
        && envelope.data.data !== undefined ? envelope.data : envelope;
      const rawResult: any = nested.data ?? nested.items ?? nested.publications ?? [];
      const result: any[] = Array.isArray(rawResult)
        ? rawResult
        : Object.values(rawResult || {});
      const from = Number(nested.from);
      const to = Number(nested.to);
      const pageRows = Number.isFinite(from) && Number.isFinite(to) && !Array.isArray(rawResult)
        ? result.slice(Math.max(0, from - 1), to)
        : result;
      const new_publications: any[] = [];
      for (const objectPublication of pageRows) {
        if (!objectPublication) continue;
        console.log('objectPublication:', objectPublication);
        const publication = await this.publicationService.updatePublicationList('MyFeedList', objectPublication);
        console.log('Publication:', publication);
        if (publication) new_publications.push(publication);
      }
      if (shouldShowLoading) {
        this.loading.dismiss();
        console.log('hiding the loading');
      }
      return new_publications;
    } catch (err) {
      if (shouldShowLoading && this.loading) this.loading.dismiss();
      console.log('error in get publications', err);
      return [];
    }
  }
  

  getSavePubFromServer(user_id ?: number, publication_type?: string) {
    return Promise.resolve(this.publicationService.getAllSavedPublications(this.current_page, (user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined));
  }
  async getPublicationsGifted(event: any, isrefresh: boolean, user_id?: number, show_loading?: boolean, publication_type?: string): Promise<any[]> {
    try {
      if (show_loading == undefined) {
        console.log('showing the loading');
        this.showLoading();
      }
      if (isrefresh == true ) {
        this.current_page = 1;
      }
      if (event !== null) {
        event.target.complete();
      }
      const data = await this.getGiftedPubFromServer(user_id ? user_id : undefined, publication_type ? publication_type : undefined);
      const result = data['data'];
      let new_publications = [];
      let to = data['to'];
      for (let i = data['from'] - 1; i < to; i++) {
        const objectPublication = result[i.toString()];
        console.log('objectPublication:', objectPublication);
        const publication = await this.publicationService.updatePublicationList('COLECCIONREGALOSLIST', objectPublication);
        console.log('Publication:', publication);
        new_publications.push(publication);
      }
      if (show_loading == undefined) {
        this.loading.dismiss();
        console.log('hiding the loading');
      }
      return new_publications;
    } catch (err) {
      this.loading.dismiss();
      console.log('error in get publications', err);
      return [];
    }
  }
  

  getGiftedPubFromServer(user_id ?: number, publication_type?: string) {
    return Promise.resolve(this.publicationService.getAllGiftedPublications(this.current_page, (user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined));
  }

  async getPublicationsPaid(event: any, isrefresh: boolean, user_id?: number, show_loading?: boolean, publication_type?: string): Promise<any[]> {
    try {
      if (show_loading == undefined) {
        console.log('showing the loading');
        this.showLoading();
      }
      if (isrefresh == true ) {
        this.current_page = 1;
      }
      if (event !== null) {
        event.target.complete();
      }
      const data = await this.getPaidPubFromServer(user_id ? user_id : undefined, publication_type ? publication_type : undefined);
      const result = data['data'];
      let new_publications = [];
      let to = data['to'];
      for (let i = data['from'] - 1; i < to; i++) {
        const objectPublication = result[i.toString()];
        console.log('objectPublication:', objectPublication);
        const publication = await this.publicationService.updatePublicationList('COLECCIONCOMPRASLIST', objectPublication);
        console.log('Publication:', publication);
        new_publications.push(publication);
      }
      if (show_loading == undefined) {
        this.loading.dismiss();
        console.log('hiding the loading');
      }
      return new_publications;
    } catch (err) {
      this.loading.dismiss();
      console.log('error in get publications', err);
      return [];
    }
  }
  

  getPaidPubFromServer(user_id ?: number, publication_type?: string) {
    return Promise.resolve(this.publicationService.getAllPaidPublications(this.current_page, (user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined));
  }

  getAIPubFromServer(user_id ?: number, publication_type?: string) {
    const authenticated = !!this.formService.profile;

    return Promise.resolve(this.publicationService.getAllAIPublications(this.current_page, (user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined, authenticated));
  }

  async getAIPublications(event: any, isrefresh: boolean, user_id?: number, show_loading?: boolean, publication_type?: string, throwOnError = false): Promise<any[]> {
    try{
     // if (show_loading == undefined) {
      //  console.log('showing the loading');
       // this.showLoading();
      //}
      if(isrefresh == true || isrefresh == null) {
        this.current_page = 1;
      }
      if (event !== null){
        event.target.complete();
      }
          let isFetchingPublications = false;
     if (isFetchingPublications) {
    console.log("Already fetching publications, ignoring new request.");
    return;
  }

   isFetchingPublications = true;
      const data = await this.getAIPubFromServer((user_id) ? user_id: undefined, (publication_type) ? publication_type: undefined);
      const result = data['data'];
      let new_publications = [];
      let to = data['to'];
      if (publication_type === 'lkfilm'){
        console.log('type1');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MylkfilmList', result[i.toString()]);
          new_publications.push(publication);
        }
      }else if (publication_type === 'earth'){
        console.log('type2');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MyearthList', result[i.toString()]);
          new_publications.push(publication);
        }
      }else if (publication_type === 'epoch'){
        console.log('type3');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MyepochList', result[i.toString()]);
          new_publications.push(publication);
        }
      }else if (publication_type === 'eclipse'){
        console.log('type4');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MyeventosList', result[i.toString()]);
          new_publications.push(publication);
        }
      }else if (publication_type === 'land'){
        console.log('type5');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MylandList', result[i.toString()]);
          new_publications.push(publication);
        }
      }else{
       // console.log('type6');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MyFeedList', result[i.toString()]);
          new_publications.push(publication);
        }
      }
    
     // if(show_loading == undefined){
       // this.loading.dismiss();
      //  console.log('hidding the loading');
     // }
      setTimeout(async () => {
     isFetchingPublications = false;
       }, 180); // Small 180ms delay

      this.indexPostsForSpotlight(new_publications, user_id);
      return new_publications;
    }
    catch (err){
     // this.loading.dismiss();
      console.log('errorr in get publications', err);
      if (throwOnError) throw err;
      return [];
    }
  }

  async getAIPublicationsByCursor(
    cursor?: string,
    user_id?: number,
    publication_type?: string,
  ): Promise<{ publications: any[]; nextCursor: string | null; hasMore: boolean }> {
    const authenticated = !!this.formService.profile;
    const data: any = await this.publicationService.getAllAIPublications(
      undefined,
      user_id,
      publication_type,
      authenticated,
      cursor,
      true,
    );
    const result = Array.isArray(data?.data) ? data.data : [];
    const listName = publication_type === 'lkfilm' || publication_type === 'LKFE'
      ? 'MylkfilmList'
      : publication_type === 'earth'
        ? 'MyearthList'
        : publication_type === 'epoch'
          ? 'MyepochList'
          : publication_type === 'eclipse'
            ? 'MyeventosList'
            : publication_type === 'land'
              ? 'MylandList'
              : 'MyFeedList';
    const publications: any[] = [];

    for (const rawPublication of result) {
      publications.push(await this.publicationService.updatePublicationList(listName, rawPublication));
    }

    return {
      publications,
      nextCursor: typeof data?.next_cursor === 'string' && data.next_cursor.length > 0
        ? data.next_cursor
        : null,
      hasMore: data?.has_more === true,
    };
  }
  
  async getUniversalLinkPublications(event: any, isrefresh: boolean, publication_id?: number, show_loading?: boolean, publication_type?: string): Promise<any[]> {
    try {
     // if (show_loading == undefined) {
       // console.log('showing the loading');
       // this.showLoading();
      //}
      if (isrefresh == true ) {
        this.current_page = 1;
      }
      if (event !== null) {
        event.target.complete();
      }
      const data = await this.getUniversalLinkPubFromServer(publication_id ? publication_id : undefined, publication_type ? publication_type : undefined);
      const result = data['data'];
      let new_publications = [];
      let to = data['to'];
      for (let i = data['from'] - 1; i < to; i++) {
        const objectPublication = result[i.toString()];
        console.log('objectPublication:', objectPublication);
        const publication = await this.publicationService.updatePublicationList('MyFeedList', objectPublication);
        console.log('Publication:', publication);
        new_publications.push(publication);
      }
      //if (show_loading == undefined) {
     //   this.loading.dismiss();
    //    console.log('hiding the loading');
    //  }
      return new_publications;
    } catch (err) {
      //this.loading.dismiss();
      console.log('error in get publications', err);
      return [];
    }
  }
  

  getUniversalLinkPubFromServer(publication_id ?: number, publication_type?: string) {
    return Promise.resolve(this.publicationService.getUniversalLinkPublications(this.current_page, (publication_id) ? publication_id: undefined, (publication_type) ? publication_type: undefined));
  }

  async getProfilePublications(event: any, isrefresh: boolean, profile_id?: number, show_loading?: boolean, publication_type?: string, pubSection?:any, explicitPage?: number, orderBy = 'created_at', orderDirection: 'asc' | 'desc' = 'desc'): Promise<any[]> {
    try {
      //if (show_loading == undefined) {
        //console.log('showing the loading');
        //this.showLoading();
      //}
      if (isrefresh == true && explicitPage === undefined) {
        this.current_page = 1;
      }
      if (event !== null) {
        event.target.complete();
      }
      // Proliferado is ordered by the relationship row (the repost event),
      // never by the publication's own created_at. Keep this rule here so
      // every profile consumer, including Mycelium and the classic profile,
      // receives the same cursor-safe ordering.
      const effectiveOrderBy = pubSection === 'Proliferado'
        ? 'proliferations.created_at'
        : orderBy;
      const data = await this.getProfilePubFromServer(
        profile_id ? profile_id : undefined,
        publication_type ? publication_type : undefined,
        pubSection ? pubSection : undefined,
        explicitPage,
        effectiveOrderBy,
        orderDirection,
      );
      const result = data['data'];
      let new_publications = [];
      const pagePublications = Array.isArray(result)
        ? result
        : Object.values(result || {});

      for (const objectPublication of pagePublications) {
        if (!objectPublication) {
          continue;
        }
        console.log('objectPublication:', objectPublication);
        const publication = await this.publicationService.updatePublicationList('MyFeedList', objectPublication);
        // updatePublicationList normalizes the row into a PublicationClass.
        // Keep the server row alongside it so consumers that need nested
        // multimedia (such as the Mycelium media grid) do not lose fields
        // during that normalization step.
        if (publication && objectPublication && publication !== objectPublication) {
          (publication as any).__sourcePublication = objectPublication;
        }
        console.log('Publication:', publication);
        new_publications.push(publication);
      }
      //if (show_loading == undefined) {
        //this.loading.dismiss();
        //console.log('hiding the loading');
      //}
      return new_publications;
    } catch (err) {
      //this.loading.dismiss();
      console.log('error in get publications', err);
      return [];
    }
  }
  

  getProfilePubFromServer(profile_id ?: number, publication_type?: string, pubSection?:any, explicitPage?: number, orderBy = 'created_at', orderDirection: 'asc' | 'desc' = 'desc') {
    const page = explicitPage ?? this.current_page;
    return Promise.resolve(this.publicationService.getProfilePublications(page, (profile_id) ? profile_id: undefined, (publication_type) ? publication_type: undefined,  pubSection ? pubSection : undefined, orderBy, orderDirection));
  }
  getPlayslistPubFromServer(user_id ?: number, playlist?: string) {
    return Promise.resolve(this.publicationService.getAllPlaylistPublications(this.current_page, (user_id) ? user_id: undefined, (playlist) ? playlist: undefined));
  }

  async getPlaylistPublications(event: any, isrefresh: boolean, user_id?: number, show_loading?: boolean, playlist?: string): Promise<any[]> {
    try{
     // if (show_loading == undefined) {
        console.log('showing the loading');
       // this.showLoading();
      //}
      if(isrefresh == true || isrefresh == null) {
        this.current_page = 1;
      }
      if (event !== null){
        event.target.complete();
      }
      const data = await this.getPlayslistPubFromServer((user_id) ? user_id: undefined, (playlist) ? playlist: undefined);
      const result = data['data'];
      let new_publications = [];
      let to = data['to'];
    
        console.log('type6');
        for (let i = data['from']-1; i<to; i++) {
          const publication = await this.publicationService.updatePublicationList('MyFeedList', result[i.toString()]);
          new_publications.push(publication);
        }
      
    
     // if(show_loading == undefined){
       // this.loading.dismiss();
      //  console.log('hidding the loading');
     // }
      return new_publications;
    }
    catch (err){
     // this.loading.dismiss();
      console.log('errorr in get publications', err);
      return [];
    }
  }
  
}
